import { render, staticRenderFns } from "./GlobalHome.vue?vue&type=template&id=84c430ac"
import script from "./GlobalHome.vue?vue&type=script&setup=true&lang=ts"
export * from "./GlobalHome.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports